export default "__VITE_ASSET__46858395__"